import { loadDyPageData as dyPageLoader } from './modules/external-systems/dynamic-yield/ChooseRequest';

dyPageLoader();

window.addEventListener('pageshow', (event) => {
  if (!event.persisted) {
    return;
  }

  const cart =
    document.querySelector('[data-cart-card-wrapper][data-state="open"]') ||
    document.querySelector('#cart');

  if (!cart) {
    return;
  }

  const loadingContent = cart.querySelector('[data-cart-content][data-loading="true"]');
  const loadingCheckout = cart.querySelector(
    'button[name="checkout"].twc-btn--loading'
  );

  if (loadingContent) {
    loadingContent.dataset.loading = 'false';
  }

  if (loadingCheckout) {
    loadingCheckout.classList.remove('twc-btn--loading');
  }
});
